import { gql } from '@apollo/client';

export const OVERRIDE_REPORT = gql`
  mutation overrideReport($reportId: ID!, $verdict: VerdictKind!, $templateKey: ID!) {
    overrideReport(reportId: $reportId, verdict: $verdict, templateKey: $templateKey) {
      report {
        id
        status
        postId
        reporterId
        reason
        category
        details
        createdAt
        assignedModeratorId
        assignedAt
      }
      wsEventSent
      emailSent
    }
  }
`;
